import { useEffect, useState } from "react";
import { observer } from 'mobx-react';
import { Grid, Box, Typography, InputAdornment, Skeleton, Chip } from "@mui/material";
import Header from "../shared/header";
import Footer from "../shared/footer";
import RoundButton from "../shared/components/round-btn";
import { Setting2, SearchNormal, Filter } from "iconsax-react";
import styles from './find-people.module.scss';
import SearchBox from "../shared/components/search-box";
import FindPeopleUiStore from "./find-people-ui-store";
import ContactCard from "../contacts/contact-card";
import Filters from "./filters";
import SettingsModal from "../contacts/settings-modal";
import { useParams } from 'react-router';

const uiStore = new FindPeopleUiStore();

const FindPeople = observer(({ history, context }) => {
    const [value, setValue] = useState('');
    const [cards, setCards] = useState([]);
    const [querySet, setQuerySet] = useState(false);
    const [loading, setLoading] = useState(false);
    const [settings, setSettings] = useState({})
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const { query } = useParams();
    const [searchFilters, setSearchFilters] = useState(null);
    const [filters, setFilters] = useState(null);

    useEffect(() => {
        async function fetchData() {
            await uiStore.initliazeContext(context);
            uiStore.fetchCards();
        }

        fetchData();
    }, [context]);


    useEffect(() => {
        if (query && !querySet) {
            setValue(query);
            fetch();
            setQuerySet(true)
        }

        async function fetch() {
            setLoading(true);
            const result = await uiStore.search(value, filters);
            setCards(result.profiles || []);
            setSearchFilters(result.filters);
            setLoading(false);
        }

    }, [filters, query, querySet, value]);

    const search = async (text, e) => {
        if(!text) text = value
        e?.preventDefault();
        setLoading(true);
        const result = await uiStore.search(text, filters);
        setSearchFilters(result.filters);
        setCards(result.profiles || []);
        setLoading(false);
    };

    return (
        <>
            <Header page="find-people"></Header>
            <Grid className='content' container>
                <Box className={styles.wrapper}>
                    <Box>
                        <Grid container>
                            <Grid item lg={7} md={6} sm={6} xs={5} sx={{ mt: 2 }}>
                                <Typography variant="h5" color='#242333'><b>Find People</b></Typography>
                            </Grid>
                            <Grid item lg={5} md={6} sm={6} xs={7} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <RoundButton
                                    startIcon={
                                        <Setting2
                                            size="24"
                                            variant="Bulk"
                                        />
                                    }
                                    variant="contained"
                                    color='lightblue'
                                    sx={{ display: { md: 'inline-flex', sm: 'none', xs: 'none' }, mr: 1, mt: 2 }}
                                    onClick={() => setShowSettingsModal(true)}
                                >

                                    Settings
                                </RoundButton>
                                <RoundButton
                                    variant="contained"
                                    color='lightblue'
                                    sx={{ display: { md: 'none', sm: 'inline-flex', xs: 'inline-flex' }, mr: 1, mt: 2 }}
                                // onClick={() => setShowFiltersModal(true)}
                                >
                                    <Filter
                                        size="24"
                                        variant="Bulk"
                                    />
                                </RoundButton>
                                <RoundButton
                                    variant="contained"
                                    color='lightblue'
                                    sx={{ display: { md: 'none', sm: 'inline-flex', xs: 'inline-flex' }, mr: 1, mt: 2 }}
                                    onClick={() => setShowSettingsModal(true)}
                                >
                                    <Setting2
                                        size="24"
                                        variant="Bulk"
                                    />
                                </RoundButton>
                            </Grid>
                        </Grid>
                    </Box>



                    <Grid container sx={{ mt: 3 }} columnSpacing={5}>
                        <Grid lg={4} md={4} display={{ md: 'block', sm: 'none', xs: 'none' }} item>
                            <Filters uiStore={uiStore} searchFilters={searchFilters} updateFilters={setFilters} previousFilters={filters} search={search} />
                        </Grid>

                        <Grid lg={8} md={8} sm={12} xs={12} item>
                            <Box
                                component="form"
                                className={styles.formBox}
                                onSubmit={(e) => search(value, e)}
                            >
                                <SearchBox
                                    fullWidth
                                    placeholder='Search...'
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchNormal
                                                    size="32"
                                                    variant="Bulk"
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                    onChange={(e) => setValue(e.target.value)}
                                    value={value}
                                />
                            </Box>

                            {!loading && !value &&
                                <Box sx={{ ml: 3 }}>
                                    <Box sx={{ mt: 3, mb: 1 }}>
                                        <Typography fontWeight={500} color='#888888'>Recently searched</Typography>
                                        <Chip variant='outlined' color="greyPrimary" onClick={() => { setValue('Mohammed'); search('Mohammed'); }} sx={{ mr: 1, mt: 1 }} label={<b>Mohammed</b>} />
                                        <Chip variant='outlined' color="greyPrimary" onClick={() => { setValue('Ahmed'); search('Ahmed'); }} sx={{ mr: 1, mt: 1 }} label={<b>Ahmed</b>} />
                                        <Chip variant='outlined' color="greyPrimary" onClick={() => { setValue('Khaled'); search('Khaled'); }} sx={{ mr: 1, mt: 1 }} label={<b>Khaled</b>} />
                                    </Box>
                                    <Box sx={{ mt: 3, mb: 1 }}>
                                        <Typography fontWeight={500} color='#888888'>Suggustion</Typography>
                                        <Chip variant='outlined' color="greyPrimary" onClick={() => { setValue('Ali'); search('Ali'); }} sx={{ mr: 1, mt: 1 }} label={<b>Ali</b>} />
                                        <Chip variant='outlined' color="greyPrimary" onClick={() => { setValue('Engineer'); search('Engineer'); }} sx={{ mr: 1, mt: 1 }} label={<b>Engineer</b>} />
                                        <Chip variant='outlined' color="greyPrimary" onClick={() => { setValue('Gaming'); search('Gaming'); }} sx={{ mr: 1, mt: 1 }} label={<b>Gaming</b>} />
                                    </Box>
                                </Box>
                            }
                            <Grid sx={{ mt: 4 }} container>
                                {loading ?
                                    <>
                                        <Skeleton variant="rounded" className={styles.cardPlaceHolder} height={230} sx={{ ml: 2, mb: 2 }} />
                                        <Skeleton variant="rounded" className={styles.cardPlaceHolder} height={230} sx={{ ml: 2, mb: 2 }} />
                                    </>
                                    :
                                    cards.map(
                                        item => (
                                            <Grid className={styles.cardGridItem} item lg={6} md={12} sm={12} xs={12}>
                                                <ContactCard
                                                    key={item._id}
                                                    card={item}
                                                    settings={settings}
                                                    uiStore={uiStore}
                                                />
                                            </Grid>
                                        )
                                    )
                                }
                            </Grid>

                        </Grid>
                    </Grid>

                </Box>
            </Grid>
            <Footer></Footer>
            <SettingsModal
                uiStore={uiStore}
                settings={settings}
                setSettings={setSettings}
                show={showSettingsModal}
                setShow={setShowSettingsModal}
                findPeople
            />
        </>
    );
});

export default FindPeople;